import localization from '../localization/index.js';

// pass the translations object to Svelte components instead

/**
 * Prepends a selected click tracker
 * @param {String} url - the url to prepend the tracker to
 * @param {String} tracker - the redirect url tracker
 * @return {String} the full url
 */
function prependClickTracker(url, tracker) {
  if (!tracker || tracker.length < 0) {
    return url;
  }
  return tracker + encodeURIComponent(url);
}

/**
 * Removes scripts and other potentially offending elements from an HTML string
 * @returns {String} - that is safe to use with Svelte's `{@html}`
 */
function safeHTML(htmlString) {
  const prohibitedTags = ['script', 'img', 'picture', 'video', 'audio', 'embed', 'object'];
  const parser = new DOMParser();
  const doc = parser.parseFromString("<div id=\"root\">".concat(htmlString, "</div>"), 'text/html');
  const root = doc.getElementById('root');
  root.querySelectorAll(prohibitedTags.join(',')).forEach(function (element) {
    return element.parentElement.removeChild(element);
  });
  return root.innerHTML;
}

/**
 * Returns a locale-specific string for a key
 * @param {String} key - key to use with a pre-defined mapping for the page locale
 * @returns {String}
 */
function l10n(key) {
  let fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return localization.getTranslationStr(key, fallback);
}
// shortcuts for `ADVERTISEMENT` and `PROMOTED_BY`
Object.defineProperties(l10n, {
  'ADVERTISEMENT': {
    get() {
      return l10n('ADVERTISEMENT', 'Advertisement');
    }
  },
  'PROMOTED_BY': {
    get() {
      return l10n('PROMOTED_BY', 'Promoted by');
    }
  }
});

/**
 * JS replacement for the `buzz_bfa` nunjucks macro
 * @param {Object} buzz - post data
 * @param {Number} [position] - position of the ad in a feed or set of items
 * @returns {String} - value for the `data-bfa` attribute
 */
function legacyBuzzBFA(buzz, position) {
  const action = '@a:click:post|dfp';
  const options = "@o:{dimension2:".concat(buzz.id, ",dimension4:").concat(buzz.titleOriginal, "}");
  const extra = "@e:{obj_type:post,obj_id:".concat(buzz.id, ",post_category:").concat(buzz.category) + (buzz.flexproVariation ? ",variation_id:".concat(buzz.flexproVariation) : '') + (position ? ",p:".concat(position) : '') + '}';
  return "".concat(action, ";").concat(options, ";").concat(extra, ";");
}
const placeholderGIFs = {
  '1:1': 'data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEAAAEALAAAAAABAAEAAAICTAEAOw==',
  '4:3': 'data:image/gif;base64,R0lGODlhBAADAIAAAP///////yH5BAEAAAEALAAAAAAEAAMAAAIDjI9WADs=',
  '16:9': 'data:image/gif;base64,R0lGODlhEAAJAIAAAP///////yH5BAEAAAEALAAAAAAQAAkAAAIKjI+py+0Po5yUFQA7'
};

/**
 * Triggers click on link element
 * @param {MouseEvent} event - mouse event object
 * @param {Element} linkToPost - element on which we need to trigger click
 */
function onImageClick(event, linkToPost) {
  try {
    // pass event to the link
    const newEvent = new MouseEvent(event.type, event);
    linkToPost.dispatchEvent(newEvent);
  } catch (e) {
    // fallback for IE
    linkToPost.click();
  }
}

export { l10n, legacyBuzzBFA, onImageClick, placeholderGIFs, prependClickTracker, safeHTML };
